export default __webpack_public_path__ + "static/media/330_dummy2016-pragentur01-de-mobile.21ba5feb.png";